import React, { useState } from 'react';
import api from './api';
import { useFermerAvecEchap } from './helpers';

function CancelProjectModal({ project, currentUser, onClose, onCancelled }) {
  useFermerAvecEchap(onClose);
  const [reason, setReason] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!reason.trim()) {
      setError('Merci de préciser la raison de l’annulation.');
      return;
    }
    setSaving(true);
    setError('');
    try {
      const res = await api.put(`/projects/${project.id}`, {
        status: 'Cancelled',
        cancel_reason: reason.trim(),
        cancelled_by: currentUser?.id,
        cancelled_at: new Date().toISOString(),
      });
      onCancelled(res.data);
    } catch (err) {
      setError("Impossible d'annuler ce projet.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" style={{ maxWidth: 460 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 style={{ margin: 0 }}>Annuler le projet</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        <p style={{ fontSize: 12.5, color: 'var(--text-secondary)', marginBottom: 14 }}>
          Cette action marquera <strong>{project.name}</strong> comme annulé. Merci d'indiquer la raison — elle sera visible sur la fiche du projet.
        </p>

        {error && <div className="error-message" style={{ marginBottom: 14 }}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Raison de l'annulation</label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Ex : budget retiré, priorité changée, projet remplacé par..."
              rows={4}
              required
            />
          </div>

          <div className="modal-footer">
            <button type="button" className="btn" onClick={onClose}>Retour</button>
            <button type="submit" className="btn btn-danger" disabled={saving}>
              {saving ? 'Annulation...' : 'Confirmer l’annulation'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CancelProjectModal;
